import gql from 'graphql-tag'

export const USUARIOS_STARTS_WITH = gql`
  query usuariosStartsWith($nome: String!) {
    usuariosByNomeOrEmailStartingWith(nome: $nome) {
      id
      nome
      email
      active
    }
  }
`
